import { authHeaders, getODataRows } from './listPageStyles';

// BELGE TÜRETME — liste ve detay ekranının paylaştığı sabitler/yardımcılar.
//
// Belge tipi listesi ve alan görünürlüğü kuralları BURADA TUTULMAZ: ikisi de backend'in kayıt
// defterinden (`/api/document-derivations/DocumentTypes`) gelir. Aynı kuralın React'te ikinci bir
// kopyası olsaydı, kayıt defterine yeni bir tip eklendiğinde ekran sessizce bayat kalırdı.

export const DERIVATION_API = '/api/document-derivations';

export const VENDOR_API = '/api/vendors';
export const CUSTOMER_API = '/api/customers';
export const REPRESENTATIVE_API = '/api/representatives';
export const WAREHOUSE_API = '/api/warehouses';

/** Müşteri kriter tipi → hangi lookup listesinden seçileceği. */
export const CRITERIA_ENDPOINTS = {
  CUSTOMER: CUSTOMER_API,
  GROUP: '/api/customergroups',
  SUBGROUP: '/api/customersubgroups',
  DYNAMIC: '/api/customerdynamicgroups',
};

/** Aile rozeti tonları. StatusBadge yalnız ok | wait | bad | neutral tanır. */
export const FAMILY_TONE = {
  ticari: 'ok',
  stok: 'wait',
  finans: 'neutral',
};

export const LOOKUP_PAGE = 30;

/** ApiResponse zarfını aç (backend Data/data ikisini de üretebiliyor). */
export function unwrap(body) {
  if (!body) return null;
  return body.data ?? body.Data ?? body;
}

/** Lookup satırından "KOD - Ad" etiketi. Ad alanı tabloya göre Name/Title olabilir. */
export function lookupLabel(item) {
  if (!item) return '';
  const code = item.textId || item.TextId || item.code || item.Code || '';
  const name = item.name || item.Name || item.title || item.Title || '';
  if (code && name) return `${code} - ${name}`;
  return name || code || '';
}

/**
 * Sunucu taraflı arama yapan lookup okuyucusu (SearchableSelect'in `fetchOptions`'ı).
 * Büyük listelerde (müşteri 4000+) tümünü indirmemek için sayfalıdır.
 */
export function makeLookupFetcher(endpoint, nameField = 'Name') {
  return async (query, skip = 0) => {
    const term = (query || '').replace(/'/g, "''").toLowerCase();
    const filter = term
      ? `contains(tolower(TextId),'${term}') or contains(tolower(${nameField}),'${term}')`
      : '';
    let url = `${endpoint}?$top=${LOOKUP_PAGE}&$skip=${skip}&$orderby=TextId`;
    if (filter) url += `&$filter=${encodeURIComponent(filter)}`;
    const res = await fetch(url, { headers: authHeaders() });
    if (!res.ok) return [];
    return getODataRows(await res.json()).map((r) => ({ value: r.id || r.Id, label: lookupLabel(r) }));
  };
}

/** Id listesinden etiket sözlüğü — çoklu seçim chip'leri ve salt-okunur gösterim için. */
export async function resolveLabels(endpoint, ids) {
  const list = (ids || []).filter(Boolean);
  if (list.length === 0) return {};
  const filter = list.map((id) => `Id eq ${id}`).join(' or ');
  const res = await fetch(`${endpoint}?$top=200&$filter=${encodeURIComponent(filter)}`, { headers: authHeaders() });
  if (!res.ok) return {};
  const map = {};
  getODataRows(await res.json()).forEach((r) => { map[r.id || r.Id] = lookupLabel(r); });
  return map;
}
